import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Icon,
  Avatar,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import styles from './styles';

class FieldDisplayMessage extends React.Component {
  render() {
    const {
      classes,
      icon,
      title,
      subTitle,
      color,
      disableGutters,
    } = this.props;
    return (
      <ListItem
        className={classes.listContainer}
        style={{
          marginBottom: disableGutters
            ? 0
            : 16,
        }}
      >
        <Avatar style={{ backgroundColor: color || '#bdbdbd' }}>
          <Icon>{icon}</Icon>
        </Avatar>
        <ListItemText primary={title} secondary={subTitle} />
      </ListItem>
    );
  }
}

FieldDisplayMessage.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.any,
  icon: PropTypes.string,
  color: PropTypes.string,
  disableGutters: PropTypes.bool,
};

FieldDisplayMessage.defaultProps = {
  classes: {},
  title: '',
  subTitle: '',
  icon: '',
  color: 'default',
  disableGutters: false,
};

export default withStyles(styles)(FieldDisplayMessage);
